export default __webpack_public_path__ + "static/media/swissimunity@3x.cd245ba9.jpg";